import React, { Component, Fragment } from 'react';
import DropdownNestedContent from './DropdownNestedContent';

/** // TODO: constants hardcode. upgrade */
const travels = 'Viajes y vacaciones';
const interiorDesign = 'Diseño de interiores';
class DropdownNested extends Component {
  state = { links: [] }

  updateLinks = (links) => {
    this.setState({
      ...this.state,
      linksSubmenu: links,
    });
  }

  render() {
    const { dataNested } = this.props;
    const { links, title, activeNestViajesLink, activeNestedInteriorDesingLink } = dataNested;
    return (
      <Fragment>
        <span className="textIndentEfect">{ title }</span>
        <span
          className="chevron chevronLeft left chevronLeftInnerSubmenuWap"
          style={{
            marginTop: '-2px',
            marginRight: '14px',
          }}
        />
        {
          activeNestViajesLink &&
            <DropdownNestedContent links={title === travels ? links : []} />
        }
        {
          activeNestedInteriorDesingLink &&
            <DropdownNestedContent links={title === interiorDesign ? links : []} />
        }
      </Fragment>
    );
  }
}

export default DropdownNested;
